module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props.props) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__bg"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__social-icons"
  }, [_c('a', {
    staticClass: "footer__phone-icon",
    attrs: {
      "href": _vm.props.props.acf.footer.phone_link
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Phone"
    }
  })], 1), _c('a', {
    staticClass: "footer__email-icon",
    attrs: {
      "href": _vm.props.props.acf.footer.email_link
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Email"
    }
  })], 1), _c('a', {
    staticClass: "footer__facebook-icon",
    attrs: {
      "href": _vm.props.props.acf.footer.facebook_link,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Facebook"
    }
  })], 1), _c('a', {
    staticClass: "footer__instagram-icon",
    attrs: {
      "href": _vm.props.props.acf.footer.instagram_link,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Instagram"
    }
  })], 1)]), _c('router-link', {
    staticClass: "footer__logo",
    attrs: {
      "to": "/",
      "aria-label": "Footer Logo"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "FooterLogo"
    }
  })], 1), _c('div', {
    staticClass: "footer__information"
  }, [_c('a', {
    staticClass: "footer__address",
    attrs: {
      "href": _vm.props.props.acf.footer.map_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.props.acf.footer.address)
    }
  }), _c('a', {
    staticClass: "footer__phone-number",
    attrs: {
      "href": _vm.props.props.acf.footer.phone_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.props.acf.footer.phone_number)
    }
  })])], 1)]), _vm._m(0), _c('div', {
    attrs: {
      "id": "accessibilityWidget",
      "tabindex": "0"
    }
  }, [_vm._v("Click for Accessibility")]), _c('a', {
    staticClass: "footer__phonetext",
    attrs: {
      "href": _vm.props.props.acf.footer.phone_link
    }
  }, [_vm._v("Text or Call us")])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__bottom-bg"
  }, [_c('div', {
    staticClass: "footer__bottom-container"
  }, [_c('a', {
    staticClass: "footer__copyright",
    attrs: {
      "href": "https://www.roostergrin.com/"
    }
  }, [_vm._v("Online Advantage by Rooster Grin")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a55a1f0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/Footer/Footer.pug
// module id = 566
// module chunks = 1